import React, { Component } from 'react';


class Step12 extends Component {

    render() {
        return (
            <div className="card card-body">

                {/* Device 5 */}
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 5</div>
                        <div className="col-sm-12 col-md-6">
                            <div className="form-group">
                                <input id="c4loc5" name="c4loc5" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <input id="c4dev5" name="c4dev5" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4correct5">Correctly Installed</label>
                                <select id="c4correct5" name="c4correct5" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>y
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4serv5">Requires Service</label>
                                <select id="c4serv5" name="c4serv5" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf5">Alarm Operation Confirmed</label>
                                <select id="c4conf5" name="c4conf5" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="cann5">Annunciation Confirmed</label>
                                <select id="c4ann5" name="c4ann5" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf5">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone5" name="c4circzone5" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4supfault5">Supervision/Ground Fault</label>
                                <select id="c4supfault5" name="c4supfault5" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf5">Remarks</label>
                                <textarea id="c4remarks5" name="c4remarks5" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>

                {/* Device 6 */}
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 6</div>
                        <div className="col-sm-12 col-md-6">
                            <div className="form-group">
                                <input id="c4loc6" name="c4loc6" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <input id="c4dev6" name="c4dev6" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4correct6">Correctly Installed</label>
                                <select id="c4correct6" name="c4correct6" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4serv6">Requires Service</label>
                                <select id="c4serv6" name="c4serv6" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf6">Alarm Operation Confirmed</label>
                                <select id="c4conf6" name="c4conf6" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="cann6">Annunciation Confirmed</label>
                                <select id="c4ann6" name="c4ann6" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf6">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone6" name="c4circzone6" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4supfault6">Supervision/Ground Fault</label>
                                <select id="c4supfault6" name="c4supfault6" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf6">Remarks</label>
                                <textarea id="c4remarks6" name="c4remarks6" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>


                {/* Device 7 */}
                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 7</div>
                        <div className="col-sm-12 col-md-6">
                            <div className="form-group">
                                <input id="c4loc7" name="c4loc7" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <input id="c4dev7" name="c4dev7" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4correct7">Correctly Installed</label>
                                <select id="c4correct7" name="c4correct7" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4serv7">Requires Service</label>
                                <select id="c4serv7" name="c4serv7" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf7">Alarm Operation Confirmed</label>
                                <select id="c4conf7" name="c4conf7" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="cann7">Annunciation Confirmed</label>
                                <select id="c4ann7" name="c4ann7" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf7">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone7" name="c4circzone7" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4supfault7">Supervision/Ground Fault</label>
                                <select id="c4supfault7" name="c4supfault7" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf7">Remarks</label>
                                <textarea id="c4remarks7" name="c4remarks7" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />
                </div>

                <div className="form-group">
                    <div className="row">
                        <div className="col-sm-12">Device 8</div>
                        <div className="col-sm-12 col-md-6">
                            <div className="form-group">
                                <input id="c4loc8" name="c4loc8" type="text" placeholder='Location' className="form-control here" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <input id="c4dev8" name="c4dev8" type="text" placeholder='Device' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4correct8">Correctly Installed</label>
                                <select id="c4correct8" name="c4correct8" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4serv8">Requires Service</label>
                                <select id="c4serv8" name="c4serv8" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf8">Alarm Operation Confirmed</label>
                                <select id="c4conf8" name="c4conf8" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="cann8">Annunciation Confirmed</label>
                                <select id="c4ann8" name="c4ann8" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf8">CIRCUIT/ZONE/POINT/ADDRESS</label>
                                <input id="c4circzone8" name="c4circzone8" type="text" placeholder='CIRCUIT/ZONE/POINT/ADDRESS' className="form-control here" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4supfault8">Supervision/Ground Fault</label>
                                <select id="c4supfault8" name="c4supfault8" className="custom-select" >
                                    <option selected value='NOT APPLICABLE'>NOT APPLICABLE</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label htmlFor="c4conf8">Remarks</label>
                                <textarea id="c4remarks8" name="c4remarks8" type="text" className="form-control here"></textarea>
                            </div>
                        </div>
                    </div>
                    <hr />


                </div>
            </div>
        );
    }
};

export default Step12;



// WEBPACK FOOTER //
// ./src/components/Step12.js